import React from 'react';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';

import { BlueCloseIcon } from '../../../images/icons/WrapSvg';

class ProductionPopup extends React.Component {
    state = {
        open: false,
        time: 0,
    };

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleChangeClick = (value) => (event) => {
        this.setState({ time: this.state.time + value });
    };

    handleChangeClick = (add) => (event) => {
        const { time } = this.state;
        const value = parseInt(time.toString().concat(add), 10);
        this.setState({ time: value });
    };

    handleRemoveUnits = (event) => {
        this.setState({ time: 0 });
    }

    handleSummitPause = (event) => {
        this.props
            .pauseLocal(this.props.id, parseInt(this.state.time, 10))
            .then(() => this.props.handleClose('production', false))
            .catch((error) => this.props.handleClose('production', error.message));
    };

    handleSummitStop = (event) => {
        this.props
            .edit({ id: this.props.id, activo: false })
            .then(() => this.props.handleClose('production', false))
            .catch((error) => this.props.handleClose('production', error.message));
    };

    render() {
        const { handleClose, intl } = this.props;
        const { time } = this.state;
        return (
            <Dialog
                onClose={() => handleClose('production', false)}
                aria-labelledby="customized-dialog-title"
                open={true}
                disableBackdropClick
                classes={{
                    paper: 'xhef_waste_popup',
                }}
            >
                <div className="flex_full_column">
                    <div className="flex_auto_row xhef_waste_popup_header align_center">
                        <IconButton
                            aria-label="Close"
                            className={''}
                            onClick={() => handleClose('production', false)}
                        >
                            <BlueCloseIcon />
                        </IconButton>
                        <div className="flex_full_row center barlowsemicondensed_bold">
                            <FormattedMessage id="xhef_popup_production_title" />
                        </div>
                    </div>
                    <div className="flex_auto_row">
                        <div className="flex_full_column padding_borders">
                            <div className="flex_auto_row align_center margin_bottom_12">
                                <TextField
                                    fullWidth
                                    id={'proyeccion'}
                                    name={'proyeccion'}
                                    required
                                    label={intl.formatMessage({
                                        id: 'xhef_popup_production_break',
                                    })}
                                    disabled={true}
                                    value={time}
                                    type="number"
                                    onChange={this.handleChange}
                                    margin="normal"
                                    InputProps={{
                                        className: 'barlowcondensed_regular c_black',
                                        endAdornment: (
                                            <InputAdornment
                                                position="end"
                                                classes={{
                                                    positionEnd:
                                                        'xhef_waste_popup_header_adornments',
                                                }}
                                            >
                                                min
                                            </InputAdornment>
                                        ),
                                    }}
                                    //eslint-disable-next-line
                                    inputProps={{
                                        pattern: '[0-9]*',
                                        style: { textAlign: 'center' },
                                    }}
                                />
                            </div>
                            <div className="flex_auto_row ">
                                <div className="flex_full_column">
                                    <div className="flex_full_row center margin_top_32 ">
                                        <Button
                                            onClick={this.handleChangeClick(0)}
                                            color="primary"
                                            variant="outlined"
                                            className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                        >
                                            0
                                        </Button>
                                        <Button
                                            onClick={this.handleChangeClick(1)}
                                            color="primary"
                                            variant="outlined"
                                            className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                        >
                                            1
                                        </Button>
                                        <Button
                                            onClick={this.handleChangeClick(2)}
                                            color="primary"
                                            variant="outlined"
                                            className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                        >
                                            2
                                        </Button>
                                        <Button
                                            onClick={this.handleChangeClick(3)}
                                            color="primary"
                                            variant="outlined"
                                            className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                        >
                                            3
                                        </Button>
                                        <Button
                                            onClick={this.handleChangeClick(4)}
                                            color="primary"
                                            variant="outlined"
                                            className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                        >
                                            4
                                        </Button>
                                    </div>
                                    <div className="flex_full_row center margin_top_32 ">
                                        <Button
                                            onClick={this.handleChangeClick(5)}
                                            color="primary"
                                            variant="outlined"
                                            className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                        >
                                            5
                                        </Button>
                                        <Button
                                            onClick={this.handleChangeClick(6)}
                                            color="primary"
                                            variant="outlined"
                                            className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                        >
                                            6
                                        </Button>
                                        <Button
                                            onClick={this.handleChangeClick(7)}
                                            color="primary"
                                            variant="outlined"
                                            className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                        >
                                            7
                                        </Button>
                                        <Button
                                            onClick={this.handleChangeClick(8)}
                                            color="primary"
                                            variant="outlined"
                                            className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                        >
                                            8
                                        </Button>
                                        <Button
                                            onClick={this.handleChangeClick(9)}
                                            color="primary"
                                            variant="outlined"
                                            className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                        >
                                            9
                                        </Button>
                                    </div>
                                </div>
                                <Button
                                    onClick={this.handleRemoveUnits}
                                    color="primary"
                                    variant="outlined"
                                    className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6 margin_top_32"
                                >
                                    {
                                        intl.formatMessage({
                                            id: 'remove',
                                        })
                                    }
                                </Button>
                            </div>
                        </div>
                    </div>
                    <div className="flex_auto_row center xhef_waste_popup_footer">
                        <Button
                            fullWidth
                            variant="contained"
                            color="primary"
                            disabled={time === 0}
                            className={'flex_full_row barlow_semibold padding_borders c_white'}
                            onClick={this.handleSummitPause}
                        >
                            <FormattedMessage id="xhef_popup_production_button_title_break" />
                        </Button>
                    </div>
                    <div className="flex_auto_row center padding_borders_equals">
                        <Button
                            fullWidth
                            variant="contained"
                            color="secondary"
                            className={
                                'flex_full_row c_white barlow_semibold padding_borders'
                            }
                            onClick={this.handleSummitStop}
                        >
                            <FormattedMessage id="xhef_popup_production_button_title_pause" />
                        </Button>
                    </div>
                </div>
            </Dialog>
        );
    }
}

ProductionPopup.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(ProductionPopup);



// WEBPACK FOOTER //
// ./src/components/complex/xhef/ProductionPopup.js